import type { Vehicle } from '../../types';

const isBEV = (vehicle: Vehicle) => {
  return 'BEV' === vehicle.fuelType.toUpperCase();
};

export default isBEV;
